export default __webpack_public_path__ + "static/media/samples.93a478d1.svg";